import {
  Component,
  effect,
  inject,
  Injector,
  OnInit,
  runInInjectionContext,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './common/navbar/navbar.component';
import { AuthService } from './services/auth/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, CommonModule],
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  authService = inject(AuthService);
  injector = inject(Injector);
  title = 'cadmus';

  constructor() {}
  ngOnInit(): void {
    this.authService.initUser();
    this.watchUser();
  }

  private watchUser() {
    runInInjectionContext(this.injector, () => {
      effect(() => {
        this.authService.currentUserSig();
      });
    });
  }
}
